import OperatorsApp from './vue/BookEasyFeed.vue';

new Vue({
    el: "#feed-app",
    name: 'Operators',
    render: h => h(OperatorsApp),
})



// WEBPACK FOOTER //
// ./scripts/bookablefeed.js